export default {
  home: '/',
  signIn: '/konsultacje/logowanie',
  registration: '/konsultacje/rejestracja',
  accountActivation: '/konsultacje/aktywacja-konta',
  passwordRecovery: '/konsultacje/odzyskiwanie-hasla',
  passwordReset: '/konsultacje/reset-hasla',
  userProfile: '/konsultacje/konto',

  consultations: '/konsultacje/',
  board: '/konsultacje/:id/forum/:threadId',
  
  budget: '/budzet/',
  budgetVote: '/budzet/glosowanie/',
  budgetForm: '/budzet/zgloszenie-projektu/',
  budgetManualVote: '/budzet/dodaj-glos/',
  budgetFormManualVote: '/budzet/dodaj-projekt/',
  myBudgetApplications: '/budzet/moje-projekty/',
  myBudgetVotes: '/budzet/moje-glosy/',
  budgetSavedApplication: '/budzet/moje-projekty/:id',
  budgetListOfSupport: '/budzet/lista-poparcia/:id',

  budgetAuth: {
    signIn: '/budzet/logowanie',
    registration: '/budzet/rejestracja',
    accountActivation: '/budzet/aktywacja-konta',
    passwordRecovery: '/budzet/odzyskiwanie-hasla',
    passwordReset: '/budzet/reset-hasla',
    userProfile: '/budzet/konto',
  },
};



// WEBPACK FOOTER //
// ./src/routePaths.js